module.exports = __webpack_public_path__ + "src/assets/img/st1.3ff08d56.svg";